import ComplaintSortMenu from './ComplaintSortMenu'

export default ComplaintSortMenu
